import { Enum, Type } from '@sinclair/typebox';
import { ProductAttrFilterMode } from '@stickerapp-org/nomisma';
import { RuleSchema } from "./condition.mjs";
export const FilterResponseSchema = Type.Object({
    id: Type.Number(),
    attributeId: Type.Number(),
    attributeName: Type.String(),
    mode: Enum(ProductAttrFilterMode),
    collectionId: Type.Number(),
    conditions: Type.Array(RuleSchema),
    versionId: Type.Number(),
});
export const CreateFilterSchema = Type.Omit(FilterResponseSchema, ['id', 'attributeName']);
export const UpdateFilterSchema = Type.Partial(Type.Omit(CreateFilterSchema, ['versionId']));
//# sourceMappingURL=filters.js.map